// Polls for an element by id across animation frames and focuses it once mounted.
// Needed when a grid cell editor is (re)mounted via a React portal and the target
// input isn't guaranteed to exist in the DOM yet on the same tick.
export function focusElementWhenReady(elementId, attemptsLeft = 10) {
  const element = document.getElementById(elementId);
  if (element) {
    element.focus();
    return;
  }
  if (attemptsLeft <= 0) {
    return;
  }
  requestAnimationFrame(() => focusElementWhenReady(elementId, attemptsLeft - 1));
}